import useSetState from "@/hooks/useSetState";
import { GoodsTypeEnum } from "constants/mall";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { ItemModalOrderVipcard } from "./item-modal-order-vipcard";
import { validateEmail } from "utils/validate";
import { rememberedInfoApi } from "../../utils/api";
import { ItemModalOrderWl } from "./item-modal-order-wl";
import { ItemModalOrderGoods } from "./item-modal-order-goods";
import { useWeb3React } from "@web3-react/core";

export const ItemModalOrder = ({ item, title, desc, windowHeight }) => {
  const { t } = useTranslation("mall");
  const { t: commonT } = useTranslation("common");
  const { account } = useWeb3React();
  const [formValues, setFormValues] = useSetState({});

  const [formErrors, setFormErrors] = useSetState({});

  const [shouldSave, setShouldSave] = useState(true);

  const validateField = (k, v) => {
    let validated = true;

    if (k === "email") {
      let emailError;
      if (v) {
        emailError = validateEmail(v) ? undefined : t("orderEmailFormatError");
      } else {
        emailError = t("orderEmailRequired");
      }

      setFormErrors({ ...formErrors, email: emailError });

      if (emailError) {
        validated = false;
      }
    }

    if (k === "wlAddress") {
      let wlAddressError;
      if (v) {
        wlAddressError = undefined;
      } else {
        wlAddressError = commonT("required");
      }

      setFormErrors({ ...formErrors, wlAddress: wlAddressError });

      if (wlAddressError) {
        validated = false;
      }
    }

    if (
      [GoodsTypeEnum.GOODS_WHITELIST, GoodsTypeEnum.GOODS_ACTIVATION].includes(
        item.goodsType
      ) &&
      k === "discordId"
    ) {
      let discordIdError;
      if (v && v.trim()) {
        discordIdError = undefined;
      } else {
        discordIdError = commonT("required");
      }

      setFormErrors({ ...formErrors, discordId: discordIdError });

      if (discordIdError) {
        validated = false;
      }
    }

    if (k === "spec") {
      let specError;
      if (v) {
        specError = undefined;
      } else {
        specError = commonT("required");
      }

      setFormErrors({ ...formErrors, spec: specError });

      if (specError) {
        validated = false;
      }
    }

    if (k === "area") {
      let areaError;
      if (v) {
        areaError = undefined;
      } else {
        areaError = commonT("required");
      }

      setFormErrors({ ...formErrors, area: areaError });

      if (areaError) {
        validated = false;
      }
    }

    if (k === "receiverAddress") {
      let receiverAddressError;
      if (v) {
        receiverAddressError = undefined;
      } else {
        receiverAddressError = commonT("required");
      }

      setFormErrors({ ...formErrors, receiverAddress: receiverAddressError });

      if (receiverAddressError) {
        validated = false;
      }
    }

    if (k === "receiver") {
      let receiverError;
      if (v) {
        receiverError = undefined;
      } else {
        receiverError = commonT("required");
      }

      setFormErrors({ ...formErrors, receiver: receiverError });

      if (receiverError) {
        validated = false;
      }
    }

    if (k === "receiverPhone") {
      let receiverPhoneError;
      if (v) {
        receiverPhoneError = undefined;
      } else {
        receiverPhoneError = commonT("required");
      }

      setFormErrors({ ...formErrors, receiverPhone: receiverPhoneError });

      if (receiverPhoneError) {
        validated = false;
      }
    }

    return validated;
  };

  const handleFieldChange = (k, v) => {
    setFormValues({ [k]: v });
    validateField(k, v);
  };

  const fetchRememberedInfo = async () => {
    const rememberedInfoApiRes = await rememberedInfoApi();

    console.log("rememberedInfoApiRes", { rememberedInfoApiRes });

    setFormValues({ area: "Mainland China" });

    if (rememberedInfoApiRes.err) {
      return;
    }

    setFormValues({
      email: rememberedInfoApiRes?.data?.contact?.emailAddress,
      twitterHandle: rememberedInfoApiRes?.data?.contact?.twitterHandle,
      phone: rememberedInfoApiRes?.data?.contact?.phoneNumber,

      wlAddress: rememberedInfoApiRes?.data?.walletAddress || account,
      discordId: rememberedInfoApiRes?.data?.discordId,

      receiverAddress: rememberedInfoApiRes?.data?.postAddress?.address,
      receiver: rememberedInfoApiRes?.data?.postAddress?.receiverName,
      receiverPhone: rememberedInfoApiRes?.data?.postAddress?.phoneNumber,
      postalCode: rememberedInfoApiRes?.data?.postAddress?.postalCode,
      // area: rememberedInfoApiRes?.data?.area,
    });
  };

  useEffect(() => {
    fetchRememberedInfo();
  }, []);

  return (
    <div className="w-[512px]">
      {item.goodsType === GoodsTypeEnum.GOODS_ACTIVATION && (
        <ItemModalOrderVipcard
          item={item}
          formValues={formValues}
          onFieldChange={handleFieldChange}
          formErrors={formErrors}
          shouldSave={shouldSave}
          setShouldSave={setShouldSave}
          validateField={validateField}
          title={title}
          windowHeight={windowHeight}
        />
      )}

      {item.goodsType === GoodsTypeEnum.GOODS_WHITELIST && (
        <ItemModalOrderWl
          item={item}
          formValues={formValues}
          onFieldChange={handleFieldChange}
          formErrors={formErrors}
          shouldSave={shouldSave}
          setShouldSave={setShouldSave}
          validateField={validateField}
          title={title}
          windowHeight={windowHeight}
        />
      )}

      {item.goodsType === GoodsTypeEnum.GOODS_POST && (
        <ItemModalOrderGoods
          item={item}
          formValues={formValues}
          onFieldChange={handleFieldChange}
          formErrors={formErrors}
          shouldSave={shouldSave}
          setShouldSave={setShouldSave}
          validateField={validateField}
          title={title}
          windowHeight={windowHeight}
        />
      )}
    </div>
  );
};
